module.exports = __webpack_public_path__ + "static/3-first-password-ee9aecb432634e870543725aef19b59f.jpg";